import { WithPanelRightPortal } from 'hocs';

import Icon from '../Icon';

export default WithPanelRightPortal(Icon);
